import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-cream selection:bg-brand-gold/30 font-sans text-brand-navy" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <RevelationSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <OfferSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <FaqSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FinalCta data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}